import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { ChurchesPage } from "@/features/domain/components/churches-page";
import { useI18n } from "@/providers/i18n-provider";

function ChurchesRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Churches`)}
      description={t(msg`Sign in to see the congregations your account has access to.`)}
    >
      <PageContainer maxWidth="3xl">
        <ChurchesPage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const churchesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/churches",
  component: ChurchesRoutePage,
});
